import React from "react"

function PendingNotice() {
  return (
    <div className="bg-yellow-300 py-6 px-4">
      <div className="container mx-auto px-3 leading-tight">
        <h3 className="text-indigo-900 font-bold mb-3">Payment Processing</h3>

        <p className="m-0 mb-1">
          We are currently processing your payment. Once your payment has been
          processed successfully, you will receive a confirmation email and you
          will be able to access exclusive content on the website.
        </p>
      </div>
    </div>
  )
}

export default PendingNotice
